import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { JournalSectionPersonnelPage } from "@/features/journal-section-personnel";
import { routes } from "@shared/lib/react-router";
import { JournalsSectionFourth } from "./ui";
import { JournalSectionFormPage } from "./ui/journal-section-form-page";
import { JournalSectionFourInfoPage } from "./ui/journal-section-four-info-page";

export const JournalsSectionFourthRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.section4()}`,
    element: createElement(JournalsSectionFourth),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionFourInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 4 }),
      },
      ...rest,
    ],
  };
};

export const JournalsSectionFourthVersionRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.journalVersionSection4()}`,
    element: createElement(JournalsSectionFourth),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionFourInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 4 }),
      },
      ...rest,
    ],
  };
};

